var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        [
          _c("van-overlay", {
            attrs: { "z-index": "9998", show: _vm.visible },
          }),
          _c("van-loading", {
            staticClass: "full-screen-loading",
            attrs: { size: "50", color: "#FFDB43" },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }